import pythonApiClient from './pythonBaseApi';

const basePath = '/mantenimientos/modulos';

export const moduloParametriaApi = {
  // Obtener parametría completa de un módulo
  getParametriaCompleta: async (moduloId) => {
    return pythonApiClient.get(`${basePath}/${moduloId}/completa`);
  },

  // ========== Géneros Permitidos ==========
  
  // Obtener géneros permitidos por módulo
  getGenerosPermitidos: async (moduloId) => {
    return pythonApiClient.get(`${basePath}/${moduloId}/generos`);
  },

  // Establecer géneros permitidos (reemplaza la lista existente)
  setGenerosPermitidos: async (moduloId, generoIds) => {
    return pythonApiClient.post(`${basePath}/${moduloId}/generos`, generoIds);
  },

  // Agregar género permitido
  addGeneroPermitido: async (moduloId, generoId) => {
    return pythonApiClient.post(`${basePath}/${moduloId}/generos/${generoId}`);
  },

  // Remover género permitido
  removeGeneroPermitido: async (moduloId, generoId) => {
    return pythonApiClient.delete(`${basePath}/${moduloId}/generos/${generoId}`);
  },

  // ========== Regímenes Permitidos ==========

  // Obtener regímenes permitidos por módulo
  getRegimenesPermitidos: async (moduloId, activoOnly = true) => {
    return pythonApiClient.get(`${basePath}/${moduloId}/regimenes`, {
      params: { activo_only: activoOnly }
    });
  },

  // Crear régimen permitido
  createRegimenPermitido: async (moduloId, regimenData) => {
    return pythonApiClient.post(`${basePath}/${moduloId}/regimenes`, regimenData);
  },

  // Actualizar régimen permitido
  updateRegimenPermitido: async (regimenId, regimenData) => {
    return pythonApiClient.put(`${basePath}/regimenes/${regimenId}`, regimenData);
  },

  // Eliminar régimen permitido
  deleteRegimenPermitido: async (regimenId) => {
    return pythonApiClient.delete(`${basePath}/regimenes/${regimenId}`);
  },

  // Validar trabajador para módulo
  validateTrabajadorForModulo: async (moduloId, generoId, regimen) => {
    return pythonApiClient.post(`${basePath}/validate`, null, {
      params: {
        modulo_id: moduloId,
        genero_id: generoId,
        regimen: regimen
      }
    });
  },

  // ========== Vista Completa y Configuración Masiva ==========

  // Obtener vista completa de regímenes
  getVistaCompletaRegimenes: async () => {
    return pythonApiClient.get(`${basePath}/regimenes/vista-completa`);
  },

  // Configuración masiva de regímenes
  setRegimenesConfiguracionMasiva: async (regimenCargoId, moduloIds) => {
    return pythonApiClient.post(`${basePath}/regimenes/masivo`, {
      regimen_cargo_id: regimenCargoId,
      modulo_ids: moduloIds
    });
  },

  // Obtener vista completa de géneros
  getVistaCompletaGeneros: async () => {
    return pythonApiClient.get(`${basePath}/generos/vista-completa`);
  },

  // Configuración masiva de géneros
  setGenerosConfiguracionMasiva: async (generoId, moduloIds) => {
    return pythonApiClient.post(`${basePath}/generos/configuracion-masiva`, {
      genero_id: generoId,
      modulo_ids: moduloIds
    });
  }
};
